<template>
  <v-row align="center" class="page-head mb-4">
    <v-col cols="12" sm="auto" class="page-head__title-col">
      <div v-if="$slots.breadcrumb" class="page-head__breadcrumb mb-1">
        <slot name="breadcrumb" />
      </div>
      <div class="page-head__title">
        <slot name="title" />
      </div>
      <div class="page-head__subtitle">
        <slot name="subtitle" />
      </div>
    </v-col>
    <v-spacer class="d-none d-sm-flex" />
    <v-col cols="12" sm="auto" class="page-head__building-col">
      <div class="building-panel">
        <v-icon small class="building-panel__icon">mdi-office-building</v-icon>
        <v-select
          label="อาคาร"
          item-text="BuildingName"
          return-object
          v-model="building"
          :items="buildingList"
          outlined
          dense
          hide-details
          class="building-select"
          :menu-props="{ maxWidth: 720, offsetY: true }"
        >
          <template v-slot:selection="{ item }">
            <span class="building-select__selection">{{ item.BuildingName }}</span>
          </template>
          <template v-slot:item="{ item }">
            <v-list-item-content>
              <v-list-item-title class="building-select__item">{{ item.BuildingName }}</v-list-item-title>
            </v-list-item-content>
          </template>
        </v-select>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('User', ['buildingList']),
    building: {
      get() {
        return this.$store.state.User.building
      },
      set(newValue) {
        this.$store.dispatch('User/SET_BUILDING', newValue)
      }
    },
  },
}
</script>

<style scoped>
.page-head__title-col {
  min-width: 0;
  flex-shrink: 1;
}

.page-head__title {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--text-primary, #111827);
  line-height: 1.3;
}

.page-head__subtitle {
  font-size: 0.875rem;
  color: var(--text-muted, #6B7280);
  margin-top: 2px;
}

.page-head__breadcrumb {
  font-size: 0.75rem;
  color: var(--text-muted, #6B7280);
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.page-head__building-col {
  flex-shrink: 0;
  min-width: 320px;
  max-width: 100%;
}

.building-panel {
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--surface-panel, #fff);
  border: 1px solid var(--border-subtle, #D1D5DB);
  border-radius: var(--radius-panel, 4px);
  padding: 4px 12px 4px 8px;
}

.building-panel__icon {
  color: var(--accent-amber, #D97706);
  flex-shrink: 0;
}

@media (min-width: 600px) {
  .page-head__building-col {
    min-width: 420px;
    max-width: 560px;
  }
}

@media (min-width: 1264px) {
  .page-head__building-col {
    min-width: 480px;
    max-width: 640px;
  }
}

.building-select {
  width: 100%;
}

.building-select >>> .v-input__slot {
  border: none !important;
  box-shadow: none !important;
}

.building-select >>> fieldset {
  border: none !important;
}

.building-select >>> .v-select__selection {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.4;
  max-height: none;
}

.building-select__selection {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.4;
  font-size: 0.875rem;
  font-weight: 500;
}

.building-select__item {
  white-space: normal;
  word-break: break-word;
  line-height: 1.4;
  font-size: 0.875rem;
}
</style>
